<template>
  <div class="chatroom">
    <div class="chatroom_section chatroom_header">
      <div class="chatroom_section chatroom_header_name">{{destination}}</div>
    </div>
    <div class="chatroom_section chatroom_history">
      <ul class="chatroom_history_list" v-if="messages.length">
        <li
          v-for="(message, index) in messages"
          :key="index"
          :class="['chatroom_history_list_item', ...{'chatroom_history_list__from': message.fromUser, 'chatroom_history_list__to': !message.fromUser}]"
          :ref="`message-${index}`">
            {{ message.text }}
        </li>
      </ul>
      <div v-else class="chatroom_section chatroom_no_messages">
        Sem mensagens encontradas
      </div>
      <!-- <div class="chatroom_history_entering">
        <div class="chatroom_history_entering_spinner"></div>
        <span class="chatroom_history_entering_label">Typing</span>
      </div> -->
    </div>
    <div class="chatroom_section chatroom_form">
      <form @submit.prevent="send">
        <input type="text" class="chatroom_form_inputbox" placeholder="Escreva aqui a sua mensagem" v-model="text">
        <button type="submit" class="btn btn-micro btn-primary chatroom_form_sendBtn" :disabled="invalidText">Enviar</button>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    destination: {
      type: String,
      required: true
    },
    messages: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      text: ''
    }
  },
  methods: {
    send: function () {
      this.$emit('new-message', this.text)
      this.text = ''
    }
  },
  computed: {
    invalidText: function () {
      return this.text.trim() === ''
    }
  },
  watch: {
    messages: {
      handler: function (list) {
        this.$nextTick(() => {
          let lastMessage = this.$refs[`message-${list.length - 1}`]
          console.log(list)
          console.log('last message', lastMessage)
          if (!lastMessage) return

          lastMessage[0].scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          })
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');

$color-white:   #ffffff;
$color-grey--1: #c1c1c1;
$color-blue--1: #147efb;
$color-blue--2: #5fc9f8;
$evollu-dark: #29c4a9;

*, *::before, *::after {
  box-sizing: border-box;
}

.chatroom {
  max-width: 550px;
  width: 100%;
  margin: 5px auto 0;
  background: $color-white;
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.chatroom_section {
  padding: 0.3rem 0.1rem;
}

.chatroom_no_messages {
  // background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #34495e;
  width: 100%;
  height: 100%;
  min-height: 350px;
}

.chatroom_header {
  border-bottom: 1px solid $color-grey--1;
}

.chatroom_header_name {
  position: relative;
  // &::before {
  //   content: "<";
  //   position: absolute;
  //   top: 50%;
  //   left: 0;
  //   transform:translatey(-50%);
  //   font-weight: 900;
  // }
}

.chatroom_history {
  flex: 2;
}

.chatroom_history_list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  height: 350px;
  overflow-y: auto;
}

.chatroom_history_list_item {
  // margin-top: auto;
  margin-bottom: 20px;
  max-width: 75%;
  width: 100%;
  border-radius: 15px;
  padding: 10px 20px;
  color: $color-white;
}

.chatroom_history_list__from {
  align-self: flex-end;
  background: $evollu-dark;
  margin-right: 1rem;
}

.chatroom_history_list__to {
  align-self: flex-start;
  background: $color-grey--1;
}

.chatroom_history_list_right  {
  align-self: flex-end;
}

.chatroom_history_list_right:last-child {
  background: $color-blue--2;
}

.chatroom_history_list_item--grey {
  background: $color-grey--1;
}

.chatroom_history_list_item--blue {
  background: $color-blue--1;
}

.chatroom_history_entering {
  padding-top: 20px;
}

.chatroom_history_entering_spinner {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: $color-grey--1;
  border-radius: 50%;
  position: relative;
  margin-left: 15px;
  animation: 1.5s enteringMessage linear infinite;
  animation-delay: .5s;

  &::before, &::after {
    content: "";
    width: 10px;
    height: 10px;
    background: $color-grey--1;
    border-radius: 50%;
    position: absolute;
    top: 0;
  }
  &::before {
    left: -15px;
    animation: 1.5s enteringMessage linear infinite;
  }
   &::after {
    left: 15px;
    animation: 1.5s enteringMessage linear infinite;
    animation-delay: .75s;
  }
}

.chatroom_history_entering_label {
  display: inline-block;
  margin-left: 15px;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
}

.chatroom_form {
  border-top: 1px solid $color-grey--1;
  form {
    display: flex;
    justify-content: space-between;
  }
}

.chatroom_form_inputbox {
  background: #d3d3d3;
  padding-left: 0.5rem;
  border: 0;
  border-radius: 10px;
  flex-basis: 80%;
  max-width: 80%;
}

.chatroom_form_sendBtn {
  flex-basis: 15%;
  max-width: 15%;
  border-radius: 10px;
}

@keyframes enteringMessage {
  0% {
    transform: scale(1);
    background: rgba(139,139,139, .5);
  }
    100% {
    transform: scale(.8);
    background: rgba(139,139,139, 0);
  }
}
</style>
